import $ from 'jquery';
import Splide from "@splidejs/splide";

window.$ = window.jQuery = $;

window.bootstrap = require('bootstrap5/dist/js/bootstrap.min');
require('@fancyapps/fancybox/dist/jquery.fancybox.min');
window.TinyDatePicker = require('tiny-date-picker/dist/tiny-date-picker.min');
require('bootstrap-select-main/dist/js/bootstrap-select.min');

const $scrollToTop = $('.scroll-to-top');
$(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
        $scrollToTop.fadeIn();
    } else {
        $scrollToTop.fadeOut();
    }
});
$scrollToTop.click(function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, 300);
});

//Animate progress bar
$(".progress-bar").animate({
    width: "90%"
}, 5000);

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

function modalSocialShare(url) {
    let w = 800;
    let h = 600;
    let left = (screen.width / 2) - (w / 2);
    let top = (screen.height / 2) - (h / 2);
    return window.open(url, 'sharer', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
}

// Social links
const popupSize = {
    width: 800,
    height: 600
};
$(document).on('click', '.social-links a', function (e) {
    let verticalPos = Math.floor(($(window).width() - popupSize.width) / 2),
        horisontalPos = Math.floor(($(window).height() - popupSize.height) / 2);
    let popup = window.open($(this).prop('href'), 'social',
        'width=' + popupSize.width + ',height=' + popupSize.height +
        ',left=' + verticalPos + ',top=' + horisontalPos +
        ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');
    if (popup) {
        popup.focus();
        e.preventDefault();
    }
});

// datepicker
if ($('.datepicker').length) {
    const inputs = Array.prototype.slice.call(document.querySelectorAll('.datepicker'));
    let lengthInputs = inputs.length;
    for (let i = 0; i < lengthInputs; i++) {
        TinyDatePicker(inputs[i], {
            mode: 'dp-below',
            // Lang can be used to customize the text that is displayed
            // in the calendar. You can use this to display a different language.
            lang: {
                days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                today: 'Hoy',
                clear: 'Limpiar',
                close: 'Cerrar',
            },
            // format {Date} -> string is a function which takes a date and returns a string. It can be used to customize
            // the way a date will look in the input after the user has selected it, and is particularly
            // useful if you're targeting a non-US customer.
            format(date) {
                return date.toLocaleDateString('es-ES', {year: 'numeric', month: '2-digit', day: '2-digit'});
            },
            // parse {string|Date} -> Date is the inverse of format. If you specify one, you probably should specify the other
            // the default parse function handles whatever the new Date constructor handles. Note that
            // parse may be passed either a string or a date.
            parse(str) {
                let date = new Date(str);
                return isNaN(date) ? new Date() : date.toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            },
            // dayOffset {number} specifies which day of the week is considered the first. By default,
            // this is 0 (Sunday). Set it to 1 for Monday, 2 for Tuesday, etc.
            dayOffset: 1,
            // min {string|Date} specifies the minimum date that can be selected (inclusive).
            // All earlier dates will be disabled.
            min: '1/1/1000',
            // max {string|Date} specifies the maximum date that can be selected (inclusive).
            // All later dates will be disabled.
            max: new Date().toLocaleDateString()
        });
    }
}

// See more subjects
const $subjectList = '#subjectlist';
if ($($subjectList).length) {
    const $subjectMore = '#more-subjects';
    $($subjectMore).click(function () {
        $($subjectList + ' li:hidden').slice(0, 10).show('slow');
        if ($($subjectList + ' li').length === $($subjectList + ' li:visible').length) {
            $($subjectMore).hide();
        }
    });
}

// See more places
const $placeList = '#placelist';
if ($($placeList).length) {
    const $placeMore = '#more-places';
    $($placeMore).click(function () {
        $($placeList + ' li:hidden').slice(0, 10).show('slow');
        if ($($placeList + ' li').length === $($placeList + ' li:visible').length) {
            $($placeMore).hide();
        }
    });
}

// See more persons
const $personList = '#personlist';
if ($($personList).length) {
    const $personMore = '#more-persons';
    $($personMore).click(function () {
        $($personList + ' li:hidden').slice(0, 10).show('slow');
        if ($($personList + ' li').length === $($personList + ' li:visible').length) {
            $($personMore).hide();
        }
    });
}

// See more entities
const $entityList = '#entitylist';
if ($($entityList).length) {
    const $entityMore = '#more-entities';
    $($entityMore).click(function () {
        $($entityList + ' li:hidden').slice(0, 10).show('slow');
        if ($($entityList + ' li').length === $($entityList + ' li:visible').length) {
            $($entityMore).hide();
        }
    });
}

let element = document.getElementById('main-carousel')
if (element !== null) {
    document.addEventListener('DOMContentLoaded', function () {
        const main = new Splide('#main-carousel', {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: false,
        });

        const thumbnails = new Splide('#thumbnail-carousel', {
            fixedWidth: 100,
            fixedHeight: 100,
            gap: 10,
            rewind: true,
            pagination: false,
            isNavigation: true
        });

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
    });
}

$('.selectpicker').selectpicker({
    actionsBox: true,
    container: 'body',
    deselectAllText: 'Desmarcar todas',
    liveSearch: true,
    liveSearchNormalize: true,
    noneSelectedText: 'Ninguna seleccionada',
    noneResultsText: 'No se han encontrado resultados',
    selectAllText: 'Seleccionar todas',
    showTick: true,
    width: '100%'
});

$.fancybox.defaults.protect = true;
$('video').bind('contextmenu', function (e) {
    e.preventDefault();
    return false;
});

$('.change-cookies').on('click', function (e) {
    e.preventDefault();
});

function deleteAnalyticsCookies() {
    let analyticsCookies = ['_pk_id.1.a110', '_pk_ses.1.a110'];
    analyticsCookies.forEach(cookie => {
        document.cookie = cookie + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + location.hostname;
    });
}

function checkConsentAndDeleteCookies() {
    let consentValue = document.cookie.split('; ').find(row => row.startsWith('__cookie_consent='));
    if (consentValue) {
        consentValue = consentValue.split('=')[1];
        if (consentValue === 'false' || consentValue === '3') {
            deleteAnalyticsCookies();
        }
    }
}

const observer = new MutationObserver(() => {
    checkConsentAndDeleteCookies();
});

observer.observe(document, {childList: true, subtree: true});

document.addEventListener("DOMContentLoaded", checkConsentAndDeleteCookies);
